import React from "react";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";

interface JobTitleCardProps {
  job: {
    title: string;
    department: string;
    isAvailable: boolean;
  };
  onApply: () => void; // Handler to trigger email functionality
}

const JobTitleCard: React.FC<JobTitleCardProps> = ({ job, onApply }) => {
  const { title, department, isAvailable } = job;

  return (
    <Card
      sx={{
        maxWidth: 400,
        margin: "16px auto",
        boxShadow: 3,
        backgroundColor: isAvailable ? "white" : "gray.300",
        opacity: isAvailable ? 1 : 0.6,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: 200,
      }}
    >
      <Box
        sx={{
          height: 3,
          backgroundColor: isAvailable ? "red" : "#d9e1e7",
          borderTopLeftRadius: "4px",
          borderTopRightRadius: "4px",
        }}
      />
      <CardContent
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mt: 3,
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ mb: 1, fontWeight: "bold", textTransform: "uppercase" }}
        >
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {department}
        </Typography>
        <Box textAlign="center">
          {isAvailable ? (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#cf181f",
                color: "#ffffff",
                borderRadius: "20px",
                width: "100%",
                "&:hover": { backgroundColor: "#b3161a" },
              }}
              onClick={onApply} // Trigger the email link
            >
              Apply Now
            </Button>
          ) : (
            <Button
              variant="outlined"
              disabled
              sx={{
                backgroundColor: "#d9e1e7",
                color: "#d9e1e7",
                borderRadius: "20px",
                width: "100%",
              }}
            >
              NO JOB OPENINGS
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default JobTitleCard;
